module.exports = __webpack_public_path__ + "img/pt.bf22983f.svg";